import React from "react";
import { Link } from "react-router-dom";
import { formatPKR } from "../lib/format";

const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block animate-fade-up opacity-0"
      style={{ animationDelay: `${Math.min(index * 60, 600)}ms` }}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-sand mb-5">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="img-zoom w-full h-full object-cover"
        />
        {product.featured && (
          <div className="absolute top-4 left-4 eyebrow text-[9px] bg-cream/95 backdrop-blur px-2.5 py-1">
            Featured
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div className="eyebrow text-[10px] text-gold/90">{product.brand}</div>
        <h3 className="font-serif text-xl md:text-2xl text-ink leading-tight">
          {product.name}
        </h3>
        <div className="flex items-center justify-between mt-1">
          <div className="text-xs text-graphite tracking-wide">
            {product.volume_ml}ml · {product.category}
          </div>
          <div className="text-sm font-medium text-ink">
            {formatPKR(product.price)}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
